import { simpleFetch } from '@mobi/utils/fetch/simpleFetch'
import type { KambiBetOffer, KambiEvent } from '@mobi/api-types/kambi'

export const getKambiBetOffersByIds = ({ betOfferIds }: { betOfferIds: number[] }) =>
  simpleFetch<KambiBetOffersByIdsResponse>(
    `${window._kc.apiOfferingBaseUrl}betoffer/${betOfferIds.join(',')}?lang=en_AU&market=AU`
  )

export const getKambiBetOffersByEventIds = ({ eventIds }: { eventIds: number[] }) =>
  simpleFetch<KambiBetOffersByIdsResponse>(
    `${window._kc.apiOfferingBaseUrl}betoffer/event/${eventIds.join(',')}?lang=en_AU&market=AU&includeParticipants=true`
  )

// =====
// Types
// =====

type KambiBetOffersByIdsResponse = {
  betOffers: KambiBetOffer[]
  events: KambiEvent[]
  /** Represents a pre pack @todo determine if required */
  prePacks: never
  range: {
    start: number
    size: number
    total: number
    hasNext: boolean
  }
}
